import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {HashRouter, Route, Routes,BrowserRouter} from "react-router-dom";
import Root from "./pages/Root";
import Cas from "./pages/login/Cas";
import Logout from "./pages/Logout";
import NewBorn from "./pages/NewBorn";
import Home from "./pages/Home";
import Test from "./pages/login/Test";
import Ynnu from "./pages/login/Ynnu";
import Bsnc from "./pages/login/bsnc";
import Cqjgx from "./pages/login/cqjgx";
import Cqjtu from "./pages/login/cqjtu";
import Qjnu from "./pages/login/qjnu";
import Cqyu from "./pages/login/cqyu";
import Cdu from "./pages/login/cdu";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
var HyRouter=HashRouter
if (process.env.REACT_APP_history=='BrowserRouter'){
    HyRouter=BrowserRouter
}

root.render(
    <React.StrictMode>
        <HyRouter basename={process.env.REACT_APP_basename||undefined}>
            <Routes>
                <Route path="/" element={<Root/>}>
                    <Route path="login/logout" element={<Logout/>}/>
                    <Route path="login/cas" element={<Cas/>}/>
                    <Route path="login/ynnu" element={<Ynnu/>}/>
                    <Route path="login/bsnc" element={<Bsnc/>}/>
                    <Route path="login/cqjgx" element={<Cqjgx/>}/>
                    <Route path="login/qjnu" element={<Qjnu/>}/>
                    <Route path="login/cqyu" element={<Cqyu/>}/>
                    <Route path="login/cqjtu" element={<Cqjtu/>}/>
                    <Route path="login/cdu" element={<Cdu/>}/>
                    <Route path="login/test" element={<Test/>}/>
                    <Route path="newborn" element={<NewBorn/>}/>
                    <Route path="home" element={<Home/>}/>
                </Route>
            </Routes>
        </HyRouter>
    </React.StrictMode>
);

console.log(process.env);
